import Common from '../../Common';
import Attempt from './entry/Attempt';
import Event from './entry/Event';

const Entry = class extends Common {
	attempt: InstanceType<typeof Attempt>;
	event: InstanceType<typeof Event>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.attempt = new Attempt(headers)
		this.event = new Event(headers)
	}

	read = (entryId: id) => this.get(`/callback/entry/${entryId}`)
}

export default Entry
